export const setSelectedNode = (node) => ({
  type: 'SET_SELECTED_NODE',
  node,
});
